import { useEffect } from 'react';

const extraJsFilesCarousel = 'https://cdn.jsdelivr.net/jquery.slick/1.6.0/slick.min.js';

const useSlickCarousel = () => {
  /**
   * This code is modified from the SlickCarousel CKEditor4 plugin
   * {@link https://ckeditor.com/cke4/addon/slickcarousel}
   *
   * The carousel is added in the CMS and loaded into Articles.
   * This uses jQuery and should be ported to something else in
   * the long term.
   *
   * See custom styles in {@link @components/pages/Article/styles.module.scss}
   */
  useEffect(() => {
    if (
      !window.jQuery ||
      !document.getElementById('Carousel_1') ||
      !document.querySelector('.slickcarousel')
    )
      return;

    function initCarousel() {
      if (typeof window.jQuery.fn.slick == 'undefined') {
        loadScript(extraJsFilesCarousel, initCarousel);
        return;
      }
      const slickCarouselEl = document.querySelector('.slickcarousel');
      slickCarouselEl.classList.add('is-loaded');

      try {
        const $gallery = window.jQuery('#Carousel_1');
        const settings = $gallery.parent().attr('data-slicksettings');
        $gallery.slick(JSON.parse(decodeURIComponent(settings)));
      } catch (error) {
        window.console.error('Failed to parse SlickCarousel…deleting unit');
        slickCarouselEl?.remove();
      }
    }

    function loadScript(url, callback) {
      const scriptTag = 'script';
      const script = document.createElement(scriptTag);
      script.type = 'text/javascript';
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = callback;
      }
      script.src = url;
      document.body.appendChild(script);
    }

    initCarousel();
  }, []);
};

export default useSlickCarousel;
